<template>
  <div>
    <ThePageTitleVue>
      <h3>{{ $t('faq_2') }}</h3>
    </ThePageTitleVue>

    <div class="quesBox content">
      <div class="askBox">
        <div v-for="(item, index) in list" :key="index">
          <h3 class="main-title">{{ item.category }}</h3>
          <div v-for="(sub, subKey) in item.items" :key="subKey" class="askContent">
            <span class="subTit" @click="openClick(index, subKey)">
              <span>{{sub.title}}</span>
              <div :class="sub.open?'a-up':'a-down'"></div>
            </span>
            <div v-if="sub.open" :class="sub.open?'open-anim':'close-anim'" style="padding: 0 30px 30px 0;">
              <div v-if="isMultiProgram(sub.content)">
                <p class="subArr" v-for="(con, i) in sub.content" :key="i" v-html="con"></p>
              </div>
              <p v-else class="subContent" v-html="sub.content"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThePageTitleVue from "./home/ThePageTitle.vue"
export default {
  name: "faq",
  components: {
    ThePageTitleVue,
  },
  data(){
    return{
      list: [
        {
          category: this.$t('faq_3'),
          items: [
            {
              title: this.$t('faq_4'),
              content: this.$t('faq_5'),
            },
            {
              title: this.$t('faq_6'),
              content: this.$t('faq_7'),
            },
            {
              title: this.$t('faq_8'),
              content: this.$t('faq_9'),
            }
          ]
        },
        {
          category: this.$t('faq_10'),
          items: [
            {
              title: this.$t('faq_11'),
              content: this.$t('faq_12'),
            },
            {
              title: this.$t('faq_13'),
              content: this.$t('faq_14'),
            },
            {
              title: this.$t('faq_15'),
              content: this.$t('faq_16'),
            },
            {
              title: this.$t('faq_17'),
              content: this.$t('faq_18'),
            },
            {
              title: this.$t('faq_19'),
              content: this.$t('faq_20'),
            },
            {
              title: this.$t('faq_21'),
              content: this.$t('faq_22'),
            },
            {
              title: this.$t('faq_23'),
              content: this.$t('faq_24'),
            },
            {
              title: this.$t('faq_25'),
              content: this.$t('faq_26'),
            },
            {
              title: this.$t('faq_27'),
              content: this.$t('faq_28'),
            }
          ]
        },
        {
          category: this.$t('faq_29'),
          items: [
            {
              title: this.$t('faq_30'),
              content: this.$t('faq_31'),
            },
            {
              title: this.$t('faq_32'),
              content: this.$t('faq_33'),
            },
            {
              title: this.$t('faq_34'),
              content: this.$t('faq_35'),
            },
            {
              title: this.$t('faq_36'),
              content: this.$t('faq_37'),
            },
            {
              title: this.$t('faq_38'),
              content: this.$t('faq_39'),
            },
            {
              title: this.$t('faq_40'),
              content: this.$t('faq_41'),
            },
            {
              title: this.$t('faq_42'),
              content: this.$t('faq_43'),
            }
          ]
        }
      ]
    }
  },
  methods:{
    facebook(){
      window.open('https://www.facebook.com/WeTradeApp')
    },
    contact(){
      // window.open('support@wetrade.one')
      window.location.href = 'mailto:support@wetrade.one'
    },
    isMultiProgram(con) {
      return Array.isArray(con)
    },

    openClick(index, subKey){
      let temp = this.list[index]
      temp.items[subKey].open = temp.items[subKey].open ? false : true
      this.$set(this.list, index, temp)
    }
  },
}
</script>

<style>
@keyframes slide-anim {
  0%{transform: scale(1, 0);}
  25%{transform: scale(1, 0.25);}
  50%{transform: scale(1, 0.5);}
  75%{transform: scale(1, 0.75);}
  100%{transform: scale(1, 1);}
}
</style>

<style scoped lang="scss">
  .quesBox{
    padding-bottom: 80px;
    .askBox{
      padding: 0 190px;
      .main-title{
        height: 40px;
        font-size: 32px;
        font-family: Roboto-Bold, Roboto;
        font-weight: bold;
        color: #181D24;
        line-height: 40px;
        margin-bottom: 20px;
        margin-top: 80px;
      }
      .askTitle{
        font-size:20px;
        font-family:Roboto-Bold;
        color: #181D24;
        height: 50px;
      }
      .askContent{
        margin-bottom: 20px;
        background: #FFFFFF;
        border-radius: 6px;
        border: 1px solid #D7DDE1;
        padding: 0 30px;
        .open-anim{
          animation: slide-anim .1s ease-in;
          transition: .3s ease-in;
          transform-origin: 50% 0;
        }
        .close-anim{
          transform: scaleY(0);
          transition: transform .5s;
          transform-origin: top center;
        }
        .subTit{
          font-size:16px;
          font-weight: bolder;
          font-family:Roboto-Bold;
          color: #181D24;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          .a-up{
            background-image: url(../assets/images/a_top.png);
            background-repeat: no-repeat;
            background-size: 16px 16px;
            height: 16px;
            width: 16px;
          }
          .a-down{
            background-image: url(../assets/images/a_down.png);
            background-repeat: no-repeat;
            background-size: 16px 16px;
            height: 16px;
            width: 16px;
          }
        }
        .subContent{
          font-size:14px;
          font-family:Helvetica;
          color: #5C6E7B;
          line-height:24px;
        }
        .subArr {
          font-size:14px;
          font-family:Helvetica;
          color: #5C6E7B;
          line-height:20px;
          padding-bottom: 10px;
        }
      }
    }
  }

  .category {
    font-size:16px;
    font-family:Helvetica;
    color: #5C6E7B;
  }
</style>



// WEBPACK FOOTER //
// src/components/Faq.vue